import React, {useState} from "react";
import {Alert, Button, Card, Form} from "react-bootstrap";
import {useAuth} from "../../authprovider";
import { useTranslation } from 'react-i18next';

export default function ObjectDataCard(props){
    const {buildings} = useAuth();
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(true)
    const [building, setBuilding] = useState(props['data-building'])
    const [alert, setAlert] = useState({
        show:false,
        error:""
    })

    const startEdition = ()=>{
        setDisabled(false)
    }

    const hideAlert = ()=>{ setAlert({show:false, error: ""})}

    const saveData = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        const data = {
            name: form.name.value,
            address: form.address.value,
            code: form.code.value,
            id: building.id
        }

        setAlert({
            show:false,
            error:""
        })

        buildings.update(data, response=>{
            const {success, error, content} = response;

            if(success === true){
                setBuilding(content);
                setDisabled(true);
            } else {
                setAlert({show:true, error: error})
            }
        })

        

    }

    return (
        <div className={"col-4"}>
            <Card className={"m-2"} key={"data"}>
                <Card.Header as={"h5"}>{t('buildingData.cardTitle')}</Card.Header>
                <Card.Body>
                    <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.error}
                        </p>
                    </Alert>
                    <Form onSubmit={saveData}>
                        <Form.Group className="mb-3" controlId="formObjectName">
                            <Form.Label>{t('buildingData.nameLabel')}</Form.Label>
                            <Form.Control disabled={disabled} name={"name"} type="text" placeholder={t('buildingData.namePlaceholder')} defaultValue={ building.name} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formObjectAddress">
                            <Form.Label>{t('buildingData.addressLabel')}</Form.Label>
                            <Form.Control disabled={disabled} name={"address"} type="text" placeholder={t('buildingData.addressPlaceholder')} defaultValue={building.address} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formObjectCode">
                            <Form.Label>{t('buildingData.codeLabel')}</Form.Label>
                            <Form.Control disabled={disabled} name={"code"} type="text" placeholder={t('buildingData.codePlaceholder')} defaultValue={building.code} />
                        </Form.Group>
                    {
                        !disabled &&
                            <Button name="Zapisz" className={"float-end"} variant="primary" type={"submit"} >
                                {t('buildingData.save')}
                            </Button>
                    }

                    </Form>
                    {
                        disabled &&
                        <Button name="Edycja" variant="primary" type={"button"} onClick={startEdition} >
                            {t('buildingData.edit')}
                        </Button>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}